import { useMessageStore } from '~~/stores/message'

const useActions = ({ state }) => {
  const { API_URL } = useBaseUrl()
  const { token } = useAuthStorage()
  const { handleErrorInfo } = useCustomFetch()
  const messageStore = useMessageStore()

  const checkoutCourse = async ({
    payload,
    resolve = () => null,
    reject = () => null
  }: any) => {
    const { data, error } = await useAsyncData('checkout', () =>
      $fetch(`${API_URL}/checkout`, {
        method: 'POST',
        headers: {
          Authorization: token.value,
          'Content-Type': 'application/json'
        },
        body: payload
      })
    )

    if (!data.value && error.value) {
      handleErrorInfo(error, 'checkoutCourse')
      reject()
    }

    resolve(useResult(data.value, 'data', null))
  }

  const claimVoucherCode = async ({ params, resolve = () => null }: any) => {
    const { data, error, pending } = await useAsyncData(
      'claimVoucherCode',
      () =>
        $fetch(`${API_URL}/voucher?${params}`, {
          method: 'GET',
          headers: {
            Authorization: token.value
          }
        })
    )

    state.voucherByCode.isLoading = pending.value

    if (!data.value && error.value) {
      state.voucherByCode.isLoading = false
      messageStore.notifyStdError(useResult(error?.value, 'data.message', ''))
    }

    state.voucherByCode = {
      data: useResult(data.value, 'data', null),
      isLoading: false
    }
    resolve()
  }

  const getVouchersPublic = async ({ params, resolve = () => null }: any) => {
    const { data, error, pending } = await useAsyncData('vouchersPublic', () =>
      $fetch(`${API_URL}/vouchers/publics?${params}`, {
        method: 'GET',
        headers: {
          Authorization: token.value
        }
      })
    )

    state.vouchersPublic.isLoading = pending.value

    if (!data.value && error.value) {
      state.vouchersPublic.isLoading = false
      handleErrorInfo(error, 'getVouchersPublic')
    }

    state.vouchersPublic = {
      data: useResult(data.value, 'data', null),
      isLoading: false
    }
    resolve()
  }

  const fetchTransactions = async ({ params, resolve = () => null }: any) => {
    const { data, error, pending } = await useAsyncData('transactions', () =>
      $fetch(`${API_URL}/transactions/histories?${params}`, {
        method: 'GET',
        headers: {
          Authorization: token.value
        }
      })
    )

    state.transactions.isLoading = pending.value

    if (!data.value && error.value) {
      state.transactions.isLoading = false
      handleErrorInfo(error, 'fetchTransactions')
    }

    state.transactions = {
      data: useResult(data.value, 'data', null),
      isLoading: false
    }
    resolve()
  }

  const transactionDetailPreview = (payload: any) => {
    state.transactionDetail = payload
  }

  return {
    checkoutCourse,
    claimVoucherCode,
    getVouchersPublic,
    fetchTransactions,
    transactionDetailPreview
  }
}

export default useActions
